var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 500 500",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.999 167.615c63.094 0 114.714 51.621 114.714 114.713v91.488h-229.426v-91.488c0-63.092 51.621-114.713 114.712-114.713z",
    fill: "#60b7fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.062 439.58-75.938-43.843v-87.685h75.938l14.02 58.143z",
    fill: "#c89d8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250 308.052 4.177 10.234v67.913l-4.177 9.538-75.938 43.843v-131.528z",
    fill: "#a37767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.062 264.209 75.938 43.843-75.938 43.843-75.938-43.843z",
    fill: "#ffbf31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250 308.052v87.685l75.938 43.843 20.643-75.603-20.643-55.925z",
    fill: "#c89d8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.938 439.58 75.938-43.843v-87.685h-75.938z",
    fill: "#a37767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.938 264.209-75.938 43.843 75.938 43.843 75.938-43.843z",
    fill: "#ffbf31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.566 173.921c31.343 0 56.751-25.408 56.751-56.749 0-31.344-25.408-56.751-56.751-56.751-31.342 0-56.75 25.408-56.75 56.751 0 31.341 25.409 56.749 56.75 56.749z",
    fill: "#f0b16e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendors);
export default __webpack_public_path__ + "static/media/vendors.24a23164cc83b42946e94cebbafb5b59.svg";
export { ForwardRef as ReactComponent };